/* ===== Fallbacks & routes ===== */
const ensureJsEndpoint = (url) => (url && !url.endsWith('.js') ? `${url}.js` : url || '');
const __routes_raw = (window.QOL && window.QOL.routes) || window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update' };
const __routes = {
  cart_add_url: ensureJsEndpoint(__routes_raw.cart_add_url),
  cart_change_url: ensureJsEndpoint(__routes_raw.cart_change_url),
  cart_update_url: ensureJsEndpoint(__routes_raw.cart_update_url)
};
const __fetchConfig = () => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  credentials: 'same-origin'
});
const __debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), ms || 200); }; };
const __publish = (evt, payload) => (typeof window.publish === 'function' && evt ? window.publish(evt, payload) : undefined);
const __subscribe = (evt, cb) => (typeof window.subscribe === 'function' && evt ? window.subscribe(evt, cb) : undefined);
const __PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || { cartUpdate: 'cart:update' };

/* ===== Elements ===== */
class QuickOrderListRemoveButton extends HTMLElement {
  constructor(){ super(); this.addEventListener('click', (e)=>{ e.preventDefault(); this.closest('quick-order-list').updateQuantity(this.dataset.index, 0); }); }
}
customElements.define('quick-order-list-remove-button', QuickOrderListRemoveButton);

class QuickOrderListRemoveAllButton extends HTMLElement {
  constructor(){
    super();
    const items = {}; let has = false;
    this.quickOrderList = this.closest('quick-order-list');
    Array.from(document.querySelectorAll('[data-variant-id]')).forEach(v => {
      const q = parseInt(v.dataset.cartQty || '0', 10);
      if (q > 0){ has = true; items[parseInt(v.dataset.variantId,10)] = 0; }
    });
    if (!has) this.classList.add('hidden');
    this.actions = { confirm:'confirm', remove:'remove', cancel:'cancel' };
    this.addEventListener('click', (e)=>{
      e.preventDefault();
      const a = this.dataset.action;
      if (a===this.actions.confirm) this.toggleConfirmation(false,true);
      else if (a===this.actions.remove){ this.quickOrderList.updateMultipleQty(items); this.toggleConfirmation(true,false); }
      else if (a===this.actions.cancel) this.toggleConfirmation(true,false);
    });
  }
  toggleConfirmation(showConfirmation, showInfo){
    this.quickOrderList.querySelector('.quick-order-list-total__confirmation')?.classList.toggle('hidden', showConfirmation);
    this.quickOrderList.querySelector('.quick-order-list-total__info')?.classList.toggle('hidden', showInfo);
  }
}
customElements.define('quick-order-list-remove-all-button', QuickOrderListRemoveAllButton);

class QuickOrderList extends HTMLElement {
  constructor(){
    super();
    this.cart = document.querySelector('cart-drawer');
    this.actions = { add:'ADD', update:'UPDATE' };
    this.quickOrderListId = 'quick-order-list';
    this.variantItemStatusElement = document.getElementById('shopping-cart-variant-item-status');
    const form = this.querySelector('form');
    form.addEventListener('submit', (e)=>e.preventDefault());
    const debouncedOnChange = __debounce((e)=>this.onChange(e), (typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 200));
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  connectedCallback(){
    this.cartUpdateUnsubscriber = __subscribe(__PUB_SUB_EVENTS.cartUpdate, (event)=>{ if (event.source !== this.quickOrderListId) this.onCartUpdate(); });
    this.sectionId = this.dataset.id;
  }
  disconnectedCallback(){ if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber(); }

  onChange(event){
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.qty-input')) return;
    const value = parseInt(input.value || '0', 10);
    const cartQ = parseInt(input.dataset.cartQuantity || '0', 10);
    const index = input.dataset.index;
    const name = input.getAttribute('name');
    const delta = value - cartQ;

    if (cartQ > 0) this.updateQuantity(index, value, name, this.actions.update);
    else this.updateQuantity(index, delta <= 0 ? (value > 0 ? value : 1) : delta, name, this.actions.add);
  }

  onCartUpdate(){
    fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
      .then(r=>r.text())
      .then(html=>{
        const doc = new DOMParser().parseFromString(html,'text/html');
        const src = doc.getElementById(this.quickOrderListId);
        if (src) this.innerHTML = src.innerHTML;
      })
      .catch(console.error);
  }

  getSectionsToRender(){
    const el = document.getElementById(this.quickOrderListId);
    return [
      { id:this.quickOrderListId, section: el ? el.dataset.id : this.sectionId, selector: '.js-contents' },
      { id:'cart-icon-bubble', section:'cart-icon-bubble', selector: '.shopify-section' },
      { id:'quick-order-list-live-region-text', section:'cart-live-region-text', selector: '.shopify-section' },
      { id:'quick-order-list-total', section: el ? el.dataset.id : this.sectionId, selector: '.quick-order-list__total' },
      { id:'CartDrawer', selector:'#CartDrawer', section:'cart-drawer' }
    ];
  }

  renderSections(parsed){
    this.getSectionsToRender().forEach((s)=>{
      try {
        const sectionEl = document.getElementById(s.id);
        // Skip if the response doesn't include this section
        const raw = parsed.sections ? parsed.sections[s.section] : null;
        if (!raw || !sectionEl) return;

        if (sectionEl.parentElement && sectionEl.parentElement.classList.contains('drawer')) {
          parsed.items.length > 0 ? sectionEl.parentElement.classList.remove('is-empty') : sectionEl.parentElement.classList.add('is-empty');
          setTimeout(()=>document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.cart?.close?.bind(this.cart)));
        }
        const replaceEl = sectionEl.querySelector(s.selector) || sectionEl;
        const newHtml = this.getSectionInnerHTML(raw, s.selector);
        if (newHtml !== null) replaceEl.innerHTML = newHtml;
      } catch (e) {
        console.warn('Skipped rendering section:', s.section, e);
      }
    });
  }

  updateMultipleQty(items){
    const overlay = this.querySelector('.variant-remove-total .loading-overlay'); overlay?.classList.add('is-active');
    const body = JSON.stringify({ updates: items, sections: this.getSectionsToRender().map(s=>s.section), sections_url: window.location.pathname });
    this.updateMessage(); this.setErrorMessage();
    fetch(`${__routes.cart_update_url}`, { ...__fetchConfig(), body })
      .then(r=>r.text()).then(state=>{ this.renderSections(JSON.parse(state)); })
      .catch(()=>this.setErrorMessage('There was an error while updating your cart. Please try again.'))
      .finally(()=>overlay?.classList.remove('is-active'));
  }

  updateQuantity(id, quantity, name, action){
    this.toggleLoading(id, true);
    let route = __routes.cart_change_url;
    let body = JSON.stringify({ quantity, id, sections: this.getSectionsToRender().map(s=>s.section), sections_url: window.location.pathname });
    if (action === this.actions.add){
      route = __routes.cart_add_url;
      body = JSON.stringify({ items:[{ quantity: parseInt(quantity,10), id: parseInt(id,10) }], sections: this.getSectionsToRender().map(s=>s.section), sections_url: window.location.pathname });
    }

    this.updateMessage(); this.setErrorMessage();

    fetch(`${route}`, { ...__fetchConfig(), body })
      .then(r=>r.text())
      .then(state=>{
        const parsed = JSON.parse(state);
        const qtyEl = document.getElementById(`Quantity-${id}`);

        if (parsed.description || parsed.errors){
          document.querySelector(`[id^="Variant-${id}"] .variant-item__totals.small-hide .loading-overlay`)?.classList.add('is-active');
          this.resetQuantityInput(id, qtyEl);
          this.updateLiveRegions(id, parsed.errors || parsed.description);
          return;
        }

        this.classList.toggle('is-empty', parsed.item_count === 0);
        this.renderSections(parsed);

        let hasError = false;
        const current = parsed.items.find(i=>i.variant_id === parseInt(id,10));
        const updated = current ? current.quantity : undefined;
        if (typeof updated !== 'undefined' && qtyEl){
          const requested = parseInt(qtyEl.value || '0', 10);
          if (updated !== requested){ this.updateError(updated, id); hasError = true; }
        }

        const variantRow = document.getElementById(`Variant-${id}`);
        if (variantRow && name) variantRow.querySelector(`[name="${name}"]`)?.focus();

        __publish(__PUB_SUB_EVENTS.cartUpdate, { source: this.quickOrderListId, cartData: parsed });

        if (hasError) this.updateMessage();
        else if (action === this.actions.add) this.updateMessage(parseInt(quantity,10));
        else if (action === this.actions.update && qtyEl) this.updateMessage(parseInt(quantity,10) - parseInt(qtyEl.dataset.cartQuantity || '0', 10));
      })
      .catch((err)=>{
        document.querySelectorAll('.loading-overlay').forEach(o=>o.classList.remove('is-active'));
        this.resetQuantityInput(id); console.error(err);
        this.setErrorMessage('There was an error while updating your cart. Please try again.');
      })
      .finally(()=>this.toggleLoading(id,false));
  }

  resetQuantityInput(id, el){ const input = el ?? document.getElementById(`Quantity-${id}`); if (input) input.value = input.getAttribute('value'); }

  /* robust template + error visibility */
  setErrorMessage(message = null){
    if (!this.errorMessageTemplate){
      const tpl = document.getElementById(`QuickOrderListErrorTemplate-${this.sectionId}`);
      if (tpl) this.errorMessageTemplate = tpl.cloneNode(true);
      else { const t=document.createElement('template'); t.innerHTML = `<span class="quick-order-list-inline-error" role="alert" style="display:inline-flex;gap:.5rem;align-items:center"><span aria-hidden="true">⚠️</span><span class="quick-order-list-error-message caption-large"></span></span>`; this.errorMessageTemplate = t; }
    }
    document.querySelectorAll('.quick-order-list-error').forEach((el)=>{
      el.innerHTML = ''; if (!message) return;
      const updated = this.errorMessageTemplate.cloneNode(true);
      updated.content.querySelector('.quick-order-list-error-message').innerText = message;
      el.appendChild(updated.content);
    });
  }

  updateMessage(q = null){
    const msgs = this.querySelectorAll('.quick-order-list__message-text');
    const icons = this.querySelectorAll('.quick-order-list__message-icon');
    if (q === null || isNaN(q)){ msgs.forEach(m=>m.innerHTML=''); icons.forEach(i=>i.classList.add('hidden')); return; }
    const isNeg = q < 0, n = Math.abs(q);
    const text = isNeg ? (n===1?`${n} item removed`:`${n} items removed`) : (q===1?`${n} item added`:`${n} items added`);
    msgs.forEach(m=>m.innerHTML = text); if (!isNeg) icons.forEach(i=>i.classList.remove('hidden'));
  }

  updateError(updatedValue, id){
    const msg = typeof updatedValue === 'undefined' ? 'There was an error while updating your cart. Please try again.' : `You can only add ${updatedValue} of this item to your cart.`;
    this.updateLiveRegions(id, msg);
  }

  updateLiveRegions(id, message){
    const d = document.getElementById(`Quick-order-list-item-error-desktop-${id}`);
    const m = document.getElementById(`Quick-order-list-item-error-mobile-${id}`);
    if (d){ d.querySelector('.variant-item__error-text').innerHTML = message; d.closest('tr')?.classList.remove('hidden'); }
    if (m){ m.classList.remove('hidden'); m.querySelector('.variant-item__error-text').innerHTML = message; }

    this.variantItemStatusElement?.setAttribute('aria-hidden', true);
    const live = document.getElementById('quick-order-list-live-region-text');
    live?.setAttribute('aria-hidden', false);
    setTimeout(()=>live?.setAttribute('aria-hidden', true), 1000);
  }

  getSectionInnerHTML(html, selector){
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html,'text/html');
    const found = doc.querySelector(selector);
    // If selector isn't in this section, fall back to the section root or body
    if (found) return found.innerHTML;
    const root = doc.body?.firstElementChild || doc.body;
    return root ? root.innerHTML : '';
  }

  toggleLoading(id, enable){
    const holder = document.getElementById(this.quickOrderListId);
    const overlays = this.querySelectorAll(`#Variant-${id} .loading-overlay`);
    if (enable){ holder?.classList.add('quick-order-list__container--disabled'); overlays.forEach(o=>o.classList.add('is-active')); document.activeElement?.blur(); this.variantItemStatusElement?.setAttribute('aria-hidden', false); }
    else { holder?.classList.remove('quick-order-list__container--disabled'); overlays.forEach(o=>o.classList.remove('is-active')); }
  }
}
customElements.define('quick-order-list', QuickOrderList);

/* local +/- wiring (works alongside theme) */
document.addEventListener('click', (e)=>{
  const minus = e.target.closest('[data-qty-minus]'); const plus = e.target.closest('[data-qty-plus]');
  if (!minus && !plus) return;
  const wrap = (minus || plus).closest('[data-qty]'); const input = wrap?.querySelector('.qty-input'); if (!input) return;
  const min = parseInt(input.min || '0', 10); let val = parseInt(input.value || '0', 10);
  if (minus) val = Math.max(min, val - 1); if (plus) val = val + 1;
  input.value = val; input.dispatchEvent(new Event('change', { bubbles:true }));
});
